export default ({ sendTimeout }) => sendTimeout;
